<template>
  <div>
    <el-form :inline="true" :model="filters">
      <el-form-item label="门店">
        <tenantSelector
          size="small"
          ref="tenantSelector"
          v-model="filters.tenant"
        />
      </el-form-item>
      <el-form-item>
        <el-input
          size="small"
          v-model="filters.search"
          placeholder="请输入关键词搜索"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="queryAll"
          >查询</el-button
        >
        <!-- <el-button
          size="small"
          type="success"
          icon="el-icon-plus"
          @click="handleCreate"
          >建立接单规则</el-button
        > -->
      </el-form-item>
    </el-form>
    <div class="tab-content">
      <!-- 列表 -->
      <el-table
        size="mini"
        stripe
        border
        :data="tableData"
        highlight-current-row
        expand-on-click-node="false"
        style="width: 100%"
      >
        <el-table-column
          prop="Tenant.Name"
          label="店铺"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="Product.Code"
          label="产品代码"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="Product.Name"
          label="产品名称"
          width="100"
        ></el-table-column>
        <el-table-column prop="StockNumber" label="接单规则" min-width="180">
         
        </el-table-column>
        <el-table-column
          label="操作"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <el-button-group>
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="small"
                @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button
              >
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="pageSizesList"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :current-page.sync="pageIndex"
        ></el-pagination>
      </div>
    </div>
    <!-- 新增框 -->
    <div v-if="formVisible">
      <el-dialog
        v-dragDialog
        :title="formTitle"
        :visible.sync="formVisible"
        width="600px"
        :close-on-click-modal="false"
      >
        <el-form
          :model="dataForm"
          ref="dataForm"
          label-width="120px"
          :rules="formRules"
        >
          <el-form-item label="门店：" prop="Tenant">
            <tenantSelector ref="tenantSelector" v-model="dataForm.Tenant" />
          </el-form-item>
          <el-form-item label="产品：" prop="Product">
            <productSelector ref="productSelector" v-model="dataForm.Product" />
          </el-form-item>
          <el-form-item label="库存米数：" prop="StockCount">
            <el-input-number
              v-model.number="dataForm.StockCount"
              size="small"
              style="width: 60%"
              auto-complete="off"
              placeholder="请输入库存数量"
            ></el-input-number>
            <br/>
            <el-tag type="success">请输入当前实际库存数量。</el-tag>
          </el-form-item>
          <el-form-item label="库存台次：" prop="StockNumber">
            <el-input-number
              v-model.number="dataForm.StockNumber"
              size="small"
              style="width: 60%"
              auto-complete="off"
              placeholder="请输入库存台次"
            ></el-input-number>
            <br/>
            <el-tag type="success">请输入当前库存支持的台次。</el-tag>
          </el-form-item>
          <el-form-item label="消耗米数：" prop="HistoryCount">
            <el-input-number
              v-model="dataForm.HistoryCount"
              size="small"
              style="width: 60%"
              auto-complete="off"
              placeholder="请输入已用米数"
            ></el-input-number>
            <br/>
            <el-tag type="info">请输入已用米数。</el-tag>
          </el-form-item>
          <el-form-item label="消耗米数：" prop="HistoryNumber">
            <el-input-number
              v-model="dataForm.HistoryNumber"
              size="small"
              style="width: 60%"
              auto-complete="off"
              placeholder="请输入已用台次"
            ></el-input-number>
            <br/>
            <el-tag type="info">请输入已用台次。</el-tag>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="formVisible = false">取消</el-button>
          <el-button
            v-if="dialogStatus == 'create'"
            type="primary"
            @click="createSubmit"
            >提交</el-button
          >
          <el-button v-else type="primary" @click="updateSubmit"
            >提交</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { getPageList, save, deleteObj } from "@/api/product/stock";
import tenantSelector from "@/components/tenantSelector";
import productSelector from "@/components/productSelector";
export default {
  components: {
    tenantSelector,
    productSelector,
  },
  data() {
    return {
      filters: {
        tenant: "",
        search: "",
      },
      controllStock: true,
      tableData: [],
      total: 0,
      pageIndex: 1,
      pageSize: 5,
      pageSizesList: [5, 10, 15, 20, 30, 50],

      formTitle: "",
      formVisible: false,

      dataForm: {},
      formRules: {
        Tenant: [{ required: true, message: "请选择店铺", trigger: "change" }],
        Product: [{ required: true, message: "请选择产品", trigger: "change" }],
        StockCount: [
          { required: true, message: "请输入当前库存米数", trigger: "change" },
        ],
        HistoryCount: [
          {
            required: true,
            message: "请输入已用米数",
            trigger: "change",
          },
        ],
        StockNumber: [
          { required: true, message: "请输入库存台次", trigger: "change" },
        ],
        HistoryNumber: [
          { required: true, message: "请输入已用台次", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    queryAll() {
      let para = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        search: this.filters.search,
        tenant: this.filters.tenant ? this.filters.tenant.Key : "",
      };
      getPageList(para).then((response) => {
        if (response) {
          this.tableData = response.Items;
          this.total = response.Total || response.Items.length;
        }
      });
    },
    handleCreate() {
      this.formTitle = "新增";
      this.dataForm = {};
      this.formVisible = true;
    },
    doUpdate(row) {
      save(row).then((response) => {
        if (response) {
          this.msg.successMsg("库存已保存！");
        }
      });
    },
    createSubmit: function () {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let para = Object.assign({}, this.dataForm);
          save(para).then((response) => {
            if (response) {
              this.formVisible = false;
              this.queryAll();
            }
          });
        }
      });
    },
    handleUpdate(row) {
      this.dataForm = Object.assign({}, row);
      this.formTitle = "修改";
      this.formVisible = true;
    },

    updateSubmit: function () {
      this.$confirm("确认提交吗？", "提示", {}).then(() => {
        let para = Object.assign({}, this.dataForm);
        save(para).then((response) => {
          if (response) {
            this.formVisible = false;
            this.queryAll();
          }
        });
      });
    },
    //删除
    handleDelete: function (index, row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      }).then(() => {
        let para = { key: row.Key };
        deleteObj(para).then((response) => {
          if (response) {
            this.msg.successMsg("操作成功");
            this.queryAll();
          }
        });
      });
    },
    handleSizeChange(val) {
      var pageSize = val;
      this.pageIndex = 1;
      this.pageSize = parseInt(pageSize);
      this.$nextTick(() => this.queryAll());
    },

    handleCurrentChange(val) {
      this.pageIndex = val;
      //this.queryAll();
    },
  },
  mounted() {
   // this.queryAll();
  },
};
</script>
<style lang='scss'  scoped>
/deep/.el-tabs--border-card > .el-tabs__content {
  padding: 0;
  height: 1px;
}

.tab-content {
  margin-top: -2px;
  border: 1px solid #dcdfe6;
  border-top: 0;
  padding: 15px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
}
</style>
  